import React from "react";

export default function Cell(props) {
    const { children, className, ...remainder } = props;
    return (
        <td
            className={className ? className : "whitespace-nowrap px-6 py-2"}
            {...remainder}
        >
            {children}
        </td>
    );
}
